<template>
  <main class="home">
    <Header
      navbarType="goBack"
      :screenTitle="screenTitle"
      @clicked="goBack()"
    />
    <Alert
      :message="alertMessage"
      :alertIcon="alertIcon"
      :alertType="alertType"
      :closable="false"
    />
    <div class="p-4">
      <img
        :src="`${useAsset('img/credit-line/sorryno.png')}`"
        class="mx-auto d-block"
        alt="sorry"
      />
      <h6 class="mt-5">{{ description }}</h6>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Alert from "@/shared-components/common/Alert.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "WithdrawalUnavailable",
  components: {
    Header,
    Alert,
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const screenTitle = t("WITHDRAWAL_UNAVAILABLE_TITLE");
    const alertMessage = t("WITHDRAWAL_UNAVAILABLE_ALERT");
    const alertType = "alert-danger";
    const alertIcon = ref("fa fa-exclamation-triangle");
    let description = ref("");

    onMounted(() => {
      description.value =
        history.state?.message || t("WITHDRAWAL_UNAVAILABLE_DESCRIPTION");
    });

    const goBack = () => {
      router.back();
    };

    return {
      t,
      screenTitle,
      alertMessage,
      alertType,
      alertIcon,
      description,
      goBack,
      useAsset,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.disabled-button {
  opacity: 0.5;
}
</style>
